import { tokenStore } from "../store/tokenStore";
import { hasNativeBridge } from "../util/userAgent";
import {
    getToken as nativeGetToken,
    saveToken as nativeSaveToken,
    deleteToken as nativeDeleteToken,
} from "../common/nativeBridge";
import { getDeviceInfoSvc } from "./deviceService";
import { callClearDeviceInfoApi } from "../api/AccountApi";

function normalize(result) {
    if (!result) return null;
    if (result.tokens?.accessToken) return result.tokens;
    if (result.status === 200) {
        const t = Array.isArray(result.data) ? result.data[0] : result.data;
        if (t?.accessToken) return { accessToken: t.accessToken, refreshToken: t.refreshToken ?? null };
    }
    if (result.accessToken) return { accessToken: result.accessToken, refreshToken: result.refreshToken ?? null };
    return null;
}

function serializeToken(token) {
    try {
        return JSON.stringify(token);
    } catch (e) {
        // console.error("토큰 직렬화 오류:", e);
        return null;
    }
}

function deserializeToken(tokenStr) {
    try {
        if (!tokenStr || typeof tokenStr !== "string") return null;
        return JSON.parse(tokenStr);
    } catch (e) {
        // console.error("토큰 역직렬화 오류:", e);
        return null;
    }
}

export async function setTokenSvc(tokens) {
    if (!tokens?.accessToken) return null;
    //스토어에 토큰저장
    tokenStore.set(tokens);
    //네이티브에 토큰 저장
    if (hasNativeBridge()) {
        try { await nativeSaveToken(tokens); } catch {}
    } else {
        localStorage.setItem("token", serializeToken(tokens));
    }
    return tokens;
}

export async function clearTokenSvc() {
    //로그아웃 전 서버의 푸시 디바이스 토큰 정리(그 기기로 더는 푸시 안 감)
    if (hasNativeBridge()) {
        try {
            const d = await getDeviceInfoSvc();
            if (d?.deviceToken) await callClearDeviceInfoApi({ deviceToken: d.deviceToken });
        } catch {}
    }
    //스토어에 토큰 삭제
    tokenStore.clear();
    //네이티브에 토큰 삭제
    if (hasNativeBridge()) {
        try { await nativeDeleteToken(); } catch {}
    }else {
        localStorage.removeItem("token");
    }
}

let inFlightEnsure = null;
export async function getAccessTokenSvc() {
    const at = tokenStore.getAccessToken?.();
    //스토어 리턴
    if (at) return at;
    //모바일이 아니면 로컬스토리지에서 가져옴
    if (!hasNativeBridge()){
        const token = deserializeToken(localStorage.getItem("token"));
        if(token == null){
            return null;
        }else{
            await setTokenSvc(token);
            return token.accessToken;
        }
    }

    if (!inFlightEnsure) {
        inFlightEnsure = (async () => {
            const res = await nativeGetToken();
            if(res.status===200){
                const t = normalize(res);
                if (t?.accessToken) await setTokenSvc(t);
                return tokenStore.getAccessToken?.() || null;
            }else{
                return null;
            }
            
        })().finally(() => { inFlightEnsure = null; });
    }
    return inFlightEnsure;
}

// 사용자 Token에서 MbrId 가져오기
export async function getMbrIdFromJWT(token) {
    try {
        if (!token) return null;

        // JWT 페이로드 추출
        const base64Url = token.split('.')[1];
        if (!base64Url) return null;

        // Base64Url → Base64 변환
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

        // 디코딩 후 JSON 파싱
        const payload = JSON.parse(atob(base64));

        // mbrId 반환
        return payload.mbrId || null;
    } catch (error) {
        return null;
    }
}


export async function getRefreshTokenSvc() {
    const at = tokenStore.getRefreshToken?.();
    //스토어 리턴
    if (at) return at;
    //모바일이 아니면 로컬스토리지에서 가져옴
    if (!hasNativeBridge()){
        const token = deserializeToken(localStorage.getItem("token"));
        if(token == null){
            return null;
        }else{
            return token.refreshToken;
        }
    }

    if (!inFlightEnsure) {
        inFlightEnsure = (async () => {
            const res = await nativeGetToken();
            if(res.status===200){
                const t = normalize(res);
                if (t?.accessToken) await setTokenSvc(t);
                return tokenStore.getRefreshToken?.() || null;
            }else{
                return null;
            }
        })().finally(() => { inFlightEnsure = null; });
    }
    return inFlightEnsure;
}

